// 路由后面统一放在中控项目管理里设置
// children 子路由的 path 一定要拼接上父路由的 path 为了强制刷新页面时，能根据当前路由的路径查找到路由信息
// 路由首页和内页如何关联上，通过 parent 属性 进行设置
// 路由和菜单如何关联上的，根据菜单里的 name 属性 查找路由集合中 name相等的或 parent 包含的
// 不同菜单使用相同内页的路由时，最好的解决方法 是定义不同的路由，防止页面刷新无法初始化选中的菜单
const routes = [
    // ==================================== 数据查询开始 ===================================================
    {
        path: '/dataStatics',
        name: 'dataStatics',
        component: '/user/dataQuery/dataStatics.vue'
    },
    {
        path: '/dataQueryMain',
        name: 'dataQueryMain',
        component: '/user/dataQuery/dataQueryMain.vue',
        parent: ['dataStatics'],
        children: [
            {
                path: '/dataQueryMain/dataQueryTeacher',
                name: 'dataQueryTeacher',
                component: '/user/dataQuery/dataQueryTeacher.vue',
            },
            {
                path: '/dataQueryMain/dataQueryClass',
                name: 'dataQueryClass',
                component: '/user/dataQuery/dataQueryClass.vue',
            },
            {
                path: '/dataQueryMain/dataQueryStudent',
                name: 'dataQueryStudent',
                component: '/user/dataQuery/dataQueryStudent.vue',
            }
        ]
    },
    {
        path: '/queryTeacherDetails',
        name: 'queryTeacherDetails',
        component: '/user/dataQuery/queryTeacherDetails.vue',
        parent: ['dataStatics']
    },
    {
        path: '/queryClassDetails',
        name: 'queryClassDetails',
        component: '/user/dataQuery/queryClassDetails.vue',
        parent: ['dataStatics']
    },
    {
        path: '/queryStudentDetails',
        name: 'queryStudentDetails',
        component: '/user/dataQuery/queryStudentDetails.vue',
        parent: ['dataStatics']
    },
    // ==================================== 数据查询结束 ===================================================
    // ==================================== 账号管理开始 ===================================================
    {
        path: '/allAccount',
        name: 'allAccount',
        component: '/user/accountStatistics/allAccount.vue',
        parent: ['dataStatics']
    },
    {
        path: '/systemAccount',
        name: 'systemAccount',
        component: '/user/accountStatistics/systemAccount.vue',
        parent: ['allAccount']
    },
    {
        path: '/schoolAdminAccount',
        name: 'schoolAdminAccount',
        component: '/user/accountStatistics/schoolAdminAccount.vue',
        parent: ['allAccount']
    },
    {
        path: '/classAdminAccount',
        name: 'classAdminAccount',
        component: '/user/accountStatistics/classAdminAccount.vue',
        parent: ['allAccount']
    },
    {
        path: '/teacherAccount',
        name: 'teacherAccount',
        component: '/user/accountStatistics/teacherAccount.vue',
        parent: ['allAccount']
    },
    {
        path: '/studentAccount',
        name: 'studentAccount',
        component: '/user/accountStatistics/studentAccount.vue',
        parent: ['allAccount']
    },
    {
        path: '/platformAccount',
        name: 'platformAccount',
        component: '/user/accountStatistics/platformAccount.vue',
        parent: ['allAccount']
    },
    // ==================================== 账号管理结束 ===================================================
    // ==================================== 用户管理开始 ===================================================
    {
        path: '/schoollist',
        name: 'schoollist',
        component: '/user/userManage/school/schoolList.vue',
        isCache: true,
        children: []
    },
    {
        path: '/userMain',
        name: 'userMain',
        component: '/user/userManage/userMain.vue',
        parent: ['schoollist'],
        children: [
            {
                path: '/userMain/teacherlist',
                name: 'teacherlist',
                component: '/user/userManage/teacher/teacherList.vue'
            },
            {
                path: '/userMain/classlist',
                name: 'classlist',
                component: '/user/userManage/class/classList.vue'
            },
            {
                path: '/userMain/schoolstudent',
                name: 'schoolstudent',
                component: '/user/userManage/student/studentList.vue'
            },
            {
                path: '/userMain/reguser',
                name: 'reguser',
                component: '/user/userManage/regUser.vue'
            },
            {
                path: '/userMain/subjectleader',
                name: 'subjectleader',
                component: '/user/userManage/teacher/leaderSetting.vue'
            },
            {
                path: '/userMain/teasuboverview',
                name: 'teasuboverview',
                component: '/user/userManage/teacher/teaSubOverview.vue'
            }
        ]
    },
    {
        path: '/classtealist',
        name: 'classtealist',
        component: '/user/userManage/teacher/classTeaList.vue',
        parent: ['schoollist']
    },
    {
        path: '/classstudentlist',
        name: 'classstudentlist',
        component: '/user/userManage/student/classStudentList.vue',
        parent: ['schoollist']
    },
    {
        path: '/sliceclassstudent',
        name: 'sliceclassstudent',
        component: '/user/userManage/student/sliceClassStudent.vue',
        parent: ['schoollist']
    },
    // ==================================== 用户管理结束 ===================================================
    // ==================================== 代理商管理开始 ===================================================
    {
        path: '/agentList',
        name: 'agentList',
        component: '/agentManage/agentList.vue'
    },
    {
        path: '/agentSchoolList',
        name: 'agentSchoolList',
        component: '/views/agentManage/agentSchoolList.vue',
        parent:['agentList']
    },
    {
        path: '/applyRecord',
        name: 'applyRecord',
        component: '/agentPlatForm/applyRecord.vue',
        parent:['agentList']
    },
    {
        path: '/checkList',
        name: 'checkList',
        component: '/agentManage/checkList.vue',
        parent:['agentList']
    },
    {
        path: '/subAccount',
        name: 'subAccount',
        component: '/agentPlatForm/subAccountList.vue',
        parent:['agentList']
    },
    {
        path: '/governSchool',
        name: 'governSchool',
        component: '/agentPlatForm/governSchool.vue',
        parent:['agentList']
    },
    // ==================================== 代理商管理结束 ===================================================
    // ==================================== 应用数据开始 ===================================================
    {
        path: '/datamain',
        name: 'datamain',
        component: '/baseDataManage/index.vue',
        children: [
            {
                path: '/microclass',
                name: 'microclass',
                component: '/baseDataManage/microClass.vue'
            },
            {
                path: '/homework',
                name: 'homework',
                component: '/baseDataManage/homework.vue'
            },
            {
                path: '/resource',
                name: 'resource',
                component: '/baseDataManage/resource.vue'
            },
            {
                path: '/bkleader',
                name: 'bkleader',
                component: '/baseDataManage/bkLeader.vue'
            }
        ]

    },
    // ==================================== 应用数据结束 ===================================================
    {
        path: '/homeworkSituation',
        name: 'homeworkSituation',
        component: '/baseDataManage/homeworkSituation.vue'

    },
    {
        path: '/downloadList',
        name: 'downloadList',
        component: '/common/downloadList.vue'

    },
    {
        path: '/schoolsiteconfig',
        name: 'schoolsiteconfig',
        component: '/siteSetting/schoolSiteConfig.vue'

    },
    {
        path: '/siteconfig',
        name: 'siteconfig',
        component: '/siteSetting/siteConfig.vue'

    },
    {
        path: '/typelist',
        name: 'typelist',
        component: '/siteSetting/typeList.vue'

    },
    {
        path: '/faqDetail',
        name: 'faqDetail',
        component: '/knowledgeWarehouse/faqDetail.vue'

    },
    {
        path: '/noauth',
        name: 'noauth',
        component: '/noAuth.vue'
    },
    // ==================================== 运营管理开始 ===================================================
    {
        path: "/operamain",
        name: "operamain",
        component: '/operaManage/operaMain.vue',
        children: [
            {
                path: 'operaschoollist',
                name: 'operaschoollist',
                component: '/operaManage/schoolList.vue'
            },
            {
                path: 'operatorlist',
                name: 'operatorlist',
                component: '/operaManage/operatorList.vue'

            },
            {
                path: 'operagentlist',
                name: 'operagentlist',
                component: '/operaManage/agentList.vue'
            }
        ]
    },
    {
        path: "/authmain",
        name: "authmain",
        component: '/operaManage/auth/authMain.vue',
        parent:['operamain'],
        children: [
            {
                path: 'authschoollist',
                name: 'authschoollist',
                component: '/operaManage/auth/authSchoolList.vue'
            },
            {
                path: 'authoperalist',
                name: 'authoperalist',
                component: '/operaManage/auth/authOperaList.vue'

            },
            {
                path: 'authagentlist',
                name: 'authagentlist',
                component: '/operaManage/auth/authAgentList.vue'
            }
        ]
    },
    {
        path: "/agentoperator",
        name: "agentoperator",
        component: '/operaManage/agentOperatorList.vue'
    },
    {
        path: "/faq",
        name: "faq",
        component: '/knowledgeWarehouse/faq.vue'
    },
    {
        path: "/productUpdate",
        name: "productUpdate",
        component: '/knowledgeWarehouse/productUpdate.vue'
    },
    {
        path: "/operationFlow",
        name: "operationFlow",
        component: '/knowledgeWarehouse/operationFlow.vue'
    },
    {
        path: "/essentialSoftware",
        name: "essentialSoftware",
        component: '/knowledgeWarehouse/essentialSoftware.vue'
    },
    {
        path: "/labelManage",
        name: "labelManage",
        component: '/knowledgeWarehouse/labelManage.vue'
    },
    {
        path: "/columnManage",
        name: "columnManage",
        component: '/knowledgeWarehouse/columnManage.vue'
    }
    // ==================================== 运营管理结束 ===================================================
];
export default routes;

